import React, { useState, useEffect, useRef } from 'react';
import '../../../styles/mainContents.css'
import { updateInventoryDetailBin, fetchInventory, fetchCustomers, fetchTransfers, fetchOrders, fetchInventoryDetail } from '../../../redux/actions/PostActions';
import { useSelector, useDispatch, connect } from 'react-redux';
import { Link, Switch, useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import { Tooltip, IconButton } from '@mui/material';
import { createTheme, ThemeProvider  } from '@mui/material/styles'
import { Print  } from '@mui/icons-material'
import { superSearch } from '@codewell/super-search';
import EmptyMuiDataTable from '../../layout/EmptyMuiDataTable';
import moment from "moment";
import { FormControlLabel, Icon, Typography} from '@mui/material';
import Axios from 'axios';
import qs from 'qs';
import { BASEURL2, HEADERS } from '../../../redux/actions/index';
import InventoryDetailPrintPage from './PrintPages/InventoryDetailPrintPage'
import { createPortal } from 'react-dom';
import ReactToPrint from 'react-to-print';


function Inventory(props) {

  const dispatch = useDispatch();
  const history = useHistory();
  const handleOnClick = () => history.push('localhost:3000/login');

  const { updatedBinResponse, update_inventoryDetailBin, inventoryDetailHeaderState, fetch_inventoryDetailPrint, dispatch_Print, fetch_landingPageStates, inventoryState, inventoryDetailState, authreducerState, fetch_inventory, fetch_inventoryDetail } = props;
  const newWindow = useRef(null);

  useEffect( () => { 
    fetch_inventory(authreducerState.user) 
    
  }, []);

  let [isDialogOpen, setIsDialogOpen] = useState(false)

  const columnsInventory = [
    {
      name: "LOC",
      label: "Loc",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",          
        }}),          
        setCellProps: () => ( {style: {
          maxWidth:"72px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
      },
    },
    {
      name: "LOCNAME",
      label: "Loc Name",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),          
        setCellProps: () => ( {style: {
          maxWidth:"85px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),            
      },
    },
    {
      name: "CITY",
      label: "City",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",          
        }}),          
        setCellProps: () => ( {style: {
          maxWidth:"72px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
        }}),         
      },
    },
    {
      name: "STATE",
      label: "State",
      options: {
        filter: false,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          maxWidth:"80px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",  
          textAlign: "center",        
        }}),          
        setCellProps: () => ( {style: {
          maxWidth:"72px", 
          wordWrap: "normal", 
          padding: "14px 4px 14px 16px",
          paddingLeft: "45px",
        }}),         
      },
    },        
  ]

  const optionsInventory = {
    filterType: "checkbox",
    selectableRows: 'none',
    responsive: "standard",
    fixedHeader: true,
    download:false,
    search: true,
    searchOpen: true,    
    searchPlaceholder: 'SEARCH INVENTORY',
    onRowClick: (rowData, rowMeta) => {
      //console.log(rowData, rowMeta);
      fetch_inventoryDetail(authreducerState.user,rowData);
    },  
    
    searchProps: {
      autoFocus: false,
      onKeyUp:(e) => {
        if (e.key === 'Enter' || e.keyCode === 13) {          
          var rowsCounter = 0;
          var loc = null;
          let rowData = null;
          inventoryState.reduce( (previousValue, currentValue, currentIndex, array) => {          
            if(rowsCounter > 1){
              return null;
            }

            if(superSearch()(e.target.value, {...currentValue}).numberOfMatches>0){
              loc = currentValue['LOC']
              rowData = Object.values(currentValue);
              //console.log('rowData',rowData)
              rowsCounter++
            }

            return rowsCounter;
          }, 0)

          if(rowsCounter === 1){
            fetch_inventoryDetail(authreducerState.user,rowData);
          }
        }
      }
    }, 
    rowsPerPage: 10,   
 
  };

  const columnsInventoryDetail = [
    {
      name: "PRDID",
      label: "Prdid",
      options: {
        filter: false,
        sort: false,
        display: false,
        searchable: false,
      },
    },    
    {
      name: "LINE",
      label: "Line",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "PARTNO",
      label: "Partno",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, rowInfo) => {
          //console.log('value '+ value + ' rowData: ' + JSON.stringify(rowInfo.rowData[0]))

          return(
            
            <FormControlLabel                                
              label={value}
              sx= { 
                { '@media print': { border: 'none', background: 'none', },
                  '@media screen': { border: 'solid 2px', color: 'black', background: 'lightgreen', fontWeight: 'bold', minWidth: '-webkit-fill-available', marginLeft: '0px', ":hover" : {background: '#8cffaf'}},
                }
              }
              control={
                  <Icon></Icon>
              }
              onClick={event => {
                var prdid = rowInfo.rowData[0]
                var loc = inventoryDetailState[0]['LOC']
                const param = {'USERID': authreducerState.user.userid, 'ROLE_NAME': authreducerState.user.role_name, 'PRDID': prdid, 'INVENTORYLOC': loc}
                //console.log('USERID '+ authreducerState.user.userid + ' PRDID: ' + prdid + ' INVENTORYLOC: ' + loc )

                Axios.post(`${BASEURL2}/fetchPartnoOpenOrders`, qs.stringify(param, {indices: false}), { HEADERS })
                .then(response => { 
                  var data = response.data;
                  if(typeof(data['ERROR']) === 'undefined' && typeof(data['message']) !== 'undefined' ){               
                    // console.log('Inventory fetchPartnoOpenOrders data:' + JSON.stringify(data['message']));
                    var date = new Date();
                    var orders = window.open('', '', 'left=0,top=0,width=900,height=650,toolbar=0,scrollbars=0,status=0');
                    orders.document.write('<html><head>')
                    orders.document.write('<title>' + value + ' Open Orders</title>');
                    orders.document.write('<style type="text/css" media="print">')
                    orders.document.write(' #printBtn { display: none; }')
                    orders.document.write('</style>')
                    orders.document.write('</head>');
                    orders.document.write('<body>');
                    orders.document.write('<h2 style="margin:0; margin-bottom:4px;">Open Orders for Partno: ' + value + '</h2>');
                    orders.document.write('<p style="margin:0; margin-bottom:4px;">' + date.toLocaleDateString("en-US") + ' ' + date.toLocaleTimeString("en-US") + '</p>');
                    orders.document.write('<table style="width: 100%;">');
                    orders.document.write(`<tr>`);
                    orders.document.write(`<th>Ordered Date</th>`);
                    orders.document.write(`<th>Orderno</th>`);
                    orders.document.write(`<th>Partno Qty</th>`);
                    orders.document.write(`<th>Custname</th>`);
                    orders.document.write(`<th>City</th>`);
                    orders.document.write(`<th>State</th>`);
                    orders.document.write(`</tr>`); 
                    data['message'].forEach(row => {
                      orders.document.write(`<tr>`);
                      orders.document.write('<td style="text-align: center;">'+row.ORDERED+'</td>');
                      orders.document.write('<td style="text-align: center;">'+row.ORDERNO+'</td>');
                      orders.document.write('<td style="text-align: center;">'+row.ORDERQTY+'</td>');
                      orders.document.write('<td style="text-align: center;">'+row.CUSTNAME+'</td>');
                      orders.document.write('<td style="text-align: center;">'+row.SHIP_TO_CITY+'</td>');
                      orders.document.write('<td style="text-align: center;">'+row.SHIP_TO_STATE+'</td>');
                      orders.document.write(`</tr>`); 
                    });
                    
                    orders.document.write('</table>');
                    orders.document.write('<button id="printBtn" onclick="window.print();return false;">Print</button>');
                    orders.document.write('</body></html>');
                    orders.document.close();                    
                  }
                  else if(typeof(data['ERROR']) === 'undefined' && typeof(data['NOTIFY']) !== 'undefined' && Object.keys(data['NOTIFY']).length > 0 ){
                    console.log('Inventory fetchPartnoOpenOrders data notify:' + JSON.stringify(data['NOTIFY']));                                                    
                  }
                  else{      
                    var failedResponse = 'Inventory fetchPartnoOpenOrders Failed'
                    if(typeof(data['ERROR']) !== 'undefined'){
                      failedResponse = data['ERROR']
                    } 
      
                    console.log('Inventory fetchPartnoOpenOrders fail: ' + failedResponse);
                  } 
                })
                .catch(error => console.error(error));                              
              }}
            />
          )
        }
      },
    },
    
    {
      name: "TRANSFER_IN",
      label: "Transfer In",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "TRANSFER_OUT",
      label: "Transfer Out",
      options: {
        filter: false,
        sort: true,
      },
    },    
    {
      name: "ORDER_OUT",
      label: "Order Out",
      options: {
        filter: false,
        sort: true,
      },
    }, 
    {
      name: "ONHAND",
      label: "Onhand",
      options: {
        filter: false,
        sort: true,
      },
    }, 
    {
      name: "BLANKCOUNT",
      label: "Count",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          return (
            <span>
              <div>
                <div className='inventoryBlankCountInput'>
                </div>
              </div>
             

            </span>
          )
        },
      },
    },
    {
      name: "LAST_RECEIPT",
      label: "Last Transfer",
      options: {
        filter: false,
        sort: true,
        customBodyRender: value => {
          if(value !== null && value.includes('AGED?')){            
            return <span style={{color:"red", fontWeight:"bold"}}>AGED? {moment(new Date(value)).format('MM/DD/YYYY')}</span>;
          }
          else if(value !== null && value.includes('NOTIFY')){
            return <span style={{color:"blue", fontWeight:"bold"}}>{moment(new Date(value)).format('MM/DD/YYYY')}</span>;
          }
          else if(value !== ''){
            return moment(new Date(value)).format('MM/DD/YYYY') 
          }
          else{
            return '';
          }
          //return value === 'AGED?' ? 'AGED?' : !== '' ? moment(new Date(value)).format('MM/DD/YYYY') : '';
        },        
      },
    }, 
    {
      name: "THIRD_PARTY_BIN_1",
      label: "BIN",
      options: {
        filter: true,
        sort: true,
        setCellHeaderProps: () => ( {style: {
          width:"80px", 
          wordWrap: "normal", 
          padding: "14px 24px 14px 16px",
        }}),         
        setCellProps: () => ( {style: {
          maxWidth:"65px", 
          wordWrap: "break-word",
          padding: "14px 12px 14px 16px",
        }}),
        customBodyRender: (cellValue, rowInfo) => {
          // console.log(value, rowInfo)
          let clickedIndex = rowInfo.currentTableData[rowInfo.rowIndex].index

          return (
            <>
              {
                (authreducerState.user.role_name === undefined) ? "" :                    
                (authreducerState.user.role_name !== 'ADMIN' && authreducerState.user.role_name !== 'EDITOR') ? cellValue
                :
                  <input type="text" className={'inventoryBinInputCN'} onBlur={ (e) => {
                    
                    let prdid = rowInfo.rowData[0]
                    //console.log('onBlur', e.target.value, ' rowinfo',rowInfo, ' prdid', prdid, 'inventoryDetailHeaderState[0]', inventoryDetailHeaderState[0])
                    update_inventoryDetailBin(inventoryDetailHeaderState[0],prdid,e.target.value)
                  }}
                  maxLength={7}                
                  defaultValue={cellValue}
                  />                 
              }
            </>
          )
        },         
      },
    },                
  ]

  const componentRef = useRef();

  const PrintButton = () => (

    <Tooltip disableFocusListener title="Print">
      <span>
        <ReactToPrint
          trigger={() => <IconButton><Print /></IconButton>}
          content={() => componentRef.current}
        />
  
        <span style={{ display: "none",}}>
          <span ref={componentRef}>
            <InventoryDetailPrintPage  />
          </span>
        </span>
      </span>
    </Tooltip>
  );

  const HeaderElements = () => (
    <>
      <PrintButton />
    </>
  );

  const optionsInventoryDetail = {
    filterType: "checkbox",
    selectableRows: 'none',
    responsive: "standard",
    print: false,      
    onRowClick: (rowData, rowMeta) => {
      //console.log(rowData, rowMeta);
    },
    onChangePage (currentPage) {
      //console.log({currentPage});
     
    },
    rowsPerPage: 100,
    customToolbar: () => (<HeaderElements />),
  };  

  return (

    <div >
        <div>           
          <div id='inventoryTblId' className='landingPageTblClass'>
          
            { inventoryState !== undefined &&
                inventoryState !== null ?
                  inventoryState.length === 0 ? 
                  <EmptyMuiDataTable  title={'No Inventory'} />                   
                  : 
                  <MUIDataTable
                      title={"Inventory"}
                      data={inventoryState}
                      columns={columnsInventory}
                      options={optionsInventory}
                  />                
              : ''
            }

          </div>

          <div id='inventoryDetailTblId' className='detailTblClass'>
          
            { inventoryDetailState !== undefined && 
              inventoryDetailState != null ?
              inventoryDetailState.length > 0 ?
                <div>
                  <span >
                    <div id='inventoryDetailTblPrompt'>
                      *** For inventory count sheet printing purposes only - any necessary battery quantity changes must be emailed to directshippartner@fmpco.com ***
                    <br/>
                    <br/>
                      NOTE: BIN field saves automatically after leaving text field for partno
                    </div>

                    <MUIDataTable
                      title={
                        <table id='inventoryDetailTblHeader'>
                          <thead>
                            <tr>
                              <th colSpan={2}>Inventory Detail</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td colSpan={2}></td>                            
                            </tr>
                            <tr>
                              <td className='inventoryDetailTblHeaderLabel'>Loc:</td>  
                              <td className='inventoryDetailTblHeaderData'>{JSON.stringify(inventoryDetailHeaderState[0])}</td>                                
                            </tr>
                            <tr>
                              <td className='inventoryDetailTblHeaderLabel'>Loc Name:</td>                       
                              <td className='inventoryDetailTblHeaderData'>{inventoryDetailHeaderState[1]}</td>                                               
                            </tr>
                            <tr>                   
                              <td className='inventoryDetailTblHeaderLabel'>City:</td>       
                              <td className='inventoryDetailTblHeaderData'>{inventoryDetailHeaderState[2]}</td>       
                            </tr>                                                  
                          </tbody>
                      </table>
                    }
                      data={inventoryDetailState}
                      columns={columnsInventoryDetail}
                      options={optionsInventoryDetail}
                    />
                  </span>

                  <button type='button' id='backToInventory' onClick={()=>{window.location.href='/'}}>Back</button>
                  {/* <button type='button' id='submitOrdernoDetail' onClick={()=>{}}>Submit</button> */}
                </div>

                : ''
              : ''
            }

          </div>

          
        </div>
    </div>

  );
}


const mapStateToProps = (state) => {
  //console.log("Transfer() mapStateToProps state: " + JSON.stringify(state));

 return {
   inventoryState: state.inventory['items_fetchInventory'],   
   inventoryDetailState: state.inventory['items_fetchInventoryDetail'],  
   inventoryDetailHeaderState: state.inventory['items_fetchInventoryDetailHeader'], 
  //  updatedBinResponse: state.inventory['item_updatedBinResponse'], 
   
   authreducerState: state.authreducer

 }

};

const mapDispatchToProps = (dispatch) => {
  // console.log("Inventory() mapDispatchToProps called ");
  return {
    fetch_landingPageStates: (user) => {
      dispatch(fetchOrders(user));
      dispatch(fetchTransfers(user));
      dispatch(fetchCustomers(user));
      dispatch(fetchInventory(user));
    },         
    fetch_inventory: (user) => {
      dispatch(fetchInventory(user));
    },
    fetch_inventoryDetail: (user, loc) => {
      dispatch(fetchInventoryDetail(user, loc));
    }, 
    update_inventoryDetailBin: (loc, prdid, binValue) => {
      dispatch(updateInventoryDetailBin(loc,prdid,binValue));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Inventory);